<style>
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .menu-pc {
    visibility: visible;
  }

  .menu-movil {
    display: none;
    visibility: hidden;
  }


  /* Responsive Styles */
  @media screen and (max-width: 767px) {

    .card-container > *:not(.circle-link) ,
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }

  @media screen and (max-width: 1065px) {
    .cabeceraXL {
      display: none;
      visibility: hidden;
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }

  @media screen and (max-width: 930px) {
    .cabeceraL {
      display: none;
      visibility: hidden;
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }

  @media screen and (max-width: 796px) {
    .cabeceraM {
      display: none;
      visibility: hidden;
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }

  @media screen and (max-width: 661px) {
    .cabeceraS {
      display: none;
      visibility: hidden;
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }

  @media screen and (max-width: 528px) {
    .cabeceraXS {
      display: none;
      visibility: hidden;
    }

    .menu-pc {
      display: none;
      visibility: hidden;
    }

    .menu-movil {
      display: block;
      visibility: visible;
    }
  }
</style>

<div class="cabecera position-fixed">
  <div class="content" role="main">
    <div id="home">
        <img src="assets/cerebro.png" alt="image" height="120px">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraXS">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraXS">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraS">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraS">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraM">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraM">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraL">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraL">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraXL">
        <img src="assets/linea.png" alt="image" height="120px" class="cabeceraXL">
        <img src="assets/lapiz.png" alt="image" height="129px">
    </div>
    <ul class="nav position-fixed menu-pc">
      <li class="nav-item" [ngClass]="{'active' : inicio}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('inicio')" [routerLink]='"."' fragment="inicio">INICIO</a>
      </li>
      <li class="nav-item" [ngClass]="{'active' : sobreMi}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('sobreMi')" [routerLink]='"."' fragment="sobreMi">SOBRE MÍ</a>
      </li>
      <li class="nav-item" [ngClass]="{'active' : metodoTrabajo}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('metodoTrabajo')" [routerLink]='"."' fragment="metodoDeTrabajo">MÉTODO DE TRABAJO</a>
      </li>
      <li class="nav-item" [ngClass]="{'active' : areasIntervencion}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('areasIntervencion')" [routerLink]='"."' fragment="areasDeIntervencion">ÁREAS DE INTERVENCIÓN</a>
      </li>
      <li class="nav-item" [ngClass]="{'active' : talleres}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('talleres')" [routerLink]='"."' fragment="talleres">TALLERES</a>
      </li>
      <li class="nav-item" [ngClass]="{'active' : contacto}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('contacto')" routerLink="/contacto">CONTACTO</a>
      </li>
      <li class="nav-item" [ngClass]="{'active' : psicoanecdotas}">
        <a class="nav-link granate gloriaHallelujah" (click)="optionSelect('psicoanecdotas')" routerLink="/psicoanecdotas">PSICOANÉCDOTAS</a>
      </li>
    </ul>
    <div class="menu-movil">
      <button mat-button [matMenuTriggerFor]="menu" class="btn granate bordeGranate"><i class="material-icons">menu</i></button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('inicio')" [routerLink]='"."' fragment="inicio">INICIO</a></button>
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('sobreMi')" [routerLink]='"."' fragment="sobreMi">SOBRE MÍ</a></button>
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('metodoTrabajo')" [routerLink]='"."' fragment="metodoDeTrabajo">MÉTODO DE TRABAJO</a></button>
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('areasIntervencion')" [routerLink]='"."' fragment="areasDeIntervencion">ÁREAS DE INTERVENCIÓN</a></button>
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('talleres')" [routerLink]='"."' fragment="talleres">TALLERES</a></button>
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('contacto')" routerLink="/contacto">CONTACTO</a></button>
        <button mat-menu-item><a class="dropdown-item" (click)="optionSelect('psicoanecdotas')" routerLink="/psicoanecdotas">PSICOANÉCDOTAS</a></button>
      </mat-menu>
    </div>

    <a class="ir-arriba" [routerLink]='"."' fragment="inicio" (click)="optionSelect('inicio')"><fa-icon [icon]="faChevronUp"></fa-icon></a>
    <a class="position-fixed alert" routerLink="/contacto" (click)="optionSelect('contacto')">
        Sesiones online también disponibles
    </a>

  </div>  
</div>

<div class="fondo">
  <div class="content" role="main">
      <router-outlet></router-outlet>
  </div>
</div>
<div class="piePagina row">
  <div class="granate offset-md-1 col-lg-2">
    <img src="assets/maryPoppings.png" alt="image" height="250"> 
  </div>
  <div class="vygotsky granate comingSoon col-lg-6 mt-5">
      <p>En cada trabajo que se debe hacer, siempre hay un elemento de diversión.</p><br>
      <p>(Mary Poppins)</p>
  </div>
  <div class="granate col-lg-3 mt-5">
    <img src="assets/certificado.png" alt="image" width="400"> 
  </div>
</div>